import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { OLAF } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import { GuaranteeBannerInnerContent } from './GuaranteeBannerInnerContent';
const GuaranteeBannerHeaderContentWrapper = styled(UIFlex).withConfig({
  displayName: "GuaranteeBannerContent__GuaranteeBannerHeaderContentWrapper",
  componentId: "gy2m1t-0"
})(["background:", ";padding-top:20px;padding-left:100px;padding-right:100px;z-index:1;min-width:0;"], OLAF);
export const GuaranteeBannerContent = () => {
  return /*#__PURE__*/_jsxs(GuaranteeBannerHeaderContentWrapper, {
    align: "center",
    direction: 'row',
    justify: "between",
    children: [/*#__PURE__*/_jsx(GuaranteeBannerInnerContent, {
      contentLabel: "fullTeamVisibility",
      iconLabel: "lists"
    }), /*#__PURE__*/_jsx(GuaranteeBannerInnerContent, {
      contentLabel: "freeAccess",
      iconLabel: "tag"
    }), /*#__PURE__*/_jsx(GuaranteeBannerInnerContent, {
      contentLabel: "allYourData",
      iconLabel: "generateChart"
    })]
  });
};